module.exports = __webpack_public_path__ + "img/facebook-icn.e666c431.png";